"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _react = _interopRequireDefault(require("react"));

var _context = require("../context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Decorator for ccxIngest
 * @param {string} controllerKey - key that will be used to return controller instance
 * @returns {object} decorated component
 */
function _default(controllerKey) {
  return function Component(WrappedComponent) {
    return (
      /*#__PURE__*/
      function (_React$Component) {
        _inherits(DecoratedComponent, _React$Component);

        /**
         * constructor - bind passed down methods and set init state
         * @param {Object} props [description]
         */
        function DecoratedComponent(props) {
          var _this;

          _classCallCheck(this, DecoratedComponent);

          _this = _possibleConstructorReturn(this, _getPrototypeOf(DecoratedComponent).call(this, props));
          _this.handleWrappedRef = _this.handleWrappedRef.bind(_assertThisInitialized(_this));
          return _this;
        }
        /**
         * Provides access to the wrapped component
         * @returns {ReactElement} wrapped component
         */


        _createClass(DecoratedComponent, [{
          key: "getWrappedInstance",
          value: function getWrappedInstance() {
            return this._wrappedRef;
          }
          /**
           * Gets ref for the wrapped component
           * @param {ReactComponent} ref - the raw input component
           * @return {undefined}
           */

        }, {
          key: "handleWrappedRef",
          value: function handleWrappedRef(ref) {
            this._wrappedRef = ref;
          }
          /**
           * Lifecycle method for render
           * @returns {ReactElement} markup
           */

        }, {
          key: "render",
          value: function render() {
            var _this2 = this;

            return _react["default"].createElement(_context.IngestContext.Consumer, null, function (ccxIngest) {
              var ccxIngestResult;

              if (controllerKey && ccxIngest && ccxIngest[controllerKey]) {
                ccxIngestResult = ccxIngest[controllerKey];
              } else {
                ccxIngestResult = ccxIngest;
              }

              return _react["default"].createElement(WrappedComponent, _extends({
                ref: _this2.handleWrappedRef
              }, _this2.props, {
                ccxIngest: ccxIngestResult
              }));
            });
          }
        }]);

        return DecoratedComponent;
      }(_react["default"].Component)
    );
  };
}